import { z } from "zod";

export const RELEASE_ACCESS_WAITLIST_STATUSES = ["pending", "approved", "rejected"] as const;

export type ReleaseAccessWaitlistStatus = (typeof RELEASE_ACCESS_WAITLIST_STATUSES)[number];

export const releaseAccessWaitlistStatusSchema = z.enum(RELEASE_ACCESS_WAITLIST_STATUSES);

export const normalizeReleaseAccessEmail = (email: string): string => email.trim().toLowerCase();

export const normalizeReleaseAccessBrandUrl = (value: string): string => {
  const trimmed = value.trim();
  const withProtocol = /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
  const url = new URL(withProtocol);

  if (!/^https?:$/.test(url.protocol) || url.hostname.split(".").filter(Boolean).length < 2) {
    throw new Error("Please enter a valid website URL.");
  }

  return url.toString();
};

export const releaseAccessBrandUrlSchema = z
  .string()
  .trim()
  .min(1)
  .transform((value, ctx) => {
    try {
      return normalizeReleaseAccessBrandUrl(value);
    } catch {
      ctx.addIssue({
        code: "custom",
        message: "Please enter a valid website URL.",
      });
      return z.NEVER;
    }
  });
